import { SYSTEM_ROLE_CODE } from '../../features/permissions/lib/role-codes';
import { createFileRoute, redirect } from '@tanstack/react-router';

// Role CRUD now lives inside the unified permission-matrix screen at
// /admin/permissions (sidebar + RoleDetailHeader + NewRoleDialog). This
// route is kept only to redirect old links/bookmarks — see admin-roles-api
// spec's "Admin roles management UI" requirement.
export const Route = createFileRoute('/admin/roles')({
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user || !user.roles.includes(SYSTEM_ROLE_CODE)) {
      throw redirect({ to: '/media-units' });
    }
    throw redirect({ to: '/admin/permissions' });
  },
});
